import { getSessionToken } from '@/utils/http';
import { openLinkInTab } from '@/utils/monday';

const PROPOSAL_EDITOR_PATH = '/editor';

export interface ProposalEditorParams {
  templateId: string;
  templateName?: string;
  boardId?: number;
}

function buildProposalEditorUrl(
  params: ProposalEditorParams,
  sessionToken?: string,
): string | null {
  const boardViewBaseUrl = import.meta.env.VITE_BOARD_VIEW_URL?.trim();
  if (!boardViewBaseUrl) {
    return null;
  }

  const search = new URLSearchParams();
  search.set('templateId', params.templateId);
  if (params.templateName) {
    search.set('templateName', params.templateName);
  }
  if (params.boardId !== undefined) {
    search.set('boardId', String(params.boardId));
  }
  search.set('returnView', 'template-gallery');

  if (sessionToken) {
    search.set('sessionToken', sessionToken);
  }

  const editorPath = `${PROPOSAL_EDITOR_PATH}?${search.toString()}`;
  const base = boardViewBaseUrl.replace(/\/$/, '');
  return `${base}#/${editorPath.replace(/^\//, '')}`;
}

/**
 * Opens the board-view proposal block editor in a new tab.
 * Requires VITE_BOARD_VIEW_URL to be configured on the item view app.
 */
export async function openProposalEditorInNewTab(
  params: ProposalEditorParams,
): Promise<boolean> {
  let sessionToken: string | undefined;
  try {
    const token = await getSessionToken();
    sessionToken = token?.data ?? undefined;
  } catch {
    // Best-effort; editor tab will surface auth errors if missing.
  }

  const url = buildProposalEditorUrl(params, sessionToken);
  if (!url) {
    return false;
  }

  await openLinkInTab({ url });
  return true;
}
